import { Alert, Button, Dialog, TextField } from "@emdur/ui";
import { type ReactNode, useState } from "react";
import { PermissionRefreshAction } from "./PermissionRefreshAction";

/** One typed-name guard for revocation and the organisation's agent kill switch. */
export function TypedConfirmation({
  title,
  name,
  action,
  children,
  busy,
  error,
  onConfirm,
  onClose,
}: {
  title: string;
  name: string;
  action: string;
  children: ReactNode;
  busy: boolean;
  error: string;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const [typed, setTyped] = useState("");
  return (
    <Dialog
      title={title}
      role="alertdialog"
      isOpen
      onOpenChange={(open) => !open && !busy && onClose()}
    >
      <div className="flex flex-col gap-4">
        {children}
        <TextField
          label={`Type ${name} to confirm`}
          value={typed}
          onChange={setTyped}
          autoComplete="off"
        />
        {error && (
          <Alert tone="danger">
            {error}
            <PermissionRefreshAction when={error} />
          </Alert>
        )}
        <div className="flex flex-wrap gap-2">
          <Button
            variant="danger"
            isDisabled={typed !== name}
            isLoading={busy}
            onPress={() => typed === name && onConfirm()}
          >
            {action}
          </Button>
          <Button isDisabled={busy} onPress={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
